import { Tag } from "antd";
import { TagCloseIcon } from "themes/Icon";
import "./tag_comp.scss";

function TagComp({ color, children, key, height = 24, onClose, className }) {
  return (
    <Tag
      key={key}
      onClose={onClose}
      closable={onClose}
      closeIcon={
        onClose && (
          <span>
            <TagCloseIcon />
          </span>
        )
      }
      style={{
        height: height,
      }}
      color={color}
      className={`tag-comp  ${className ? className : ""} `}
    >
      {children}
    </Tag>
  );
}

export default TagComp;
